export const GET_MY_PROFILE = 'GET_MY_PROFILE';
